import { z } from "zod";

import { compose } from "@/common/helpers";
import { extractTranslations } from "@/services/cms";

const columnItemSchema = z.object({
  label: z.string().min(3),
  url: z.string().min(1),
  distinction: z.string().nullable().optional(),
});
const columnSchema = z.array(columnItemSchema);

export const getFooterResponseSchema = z
  .object({
    data: z.preprocess(
      compose(extractTranslations),
      z
        .object({
          translations: z.object({
            // companyMeta: z.string().min(3),
            column1: columnSchema,
            column1Label: z.string().nullable(),
            column2: columnSchema,
            column2Label: z.string().nullable(),
            column3: columnSchema,
            column3Label: z.string().nullable(),
            column4: columnSchema,
            column4Label: z.string().nullable(),
            column5: columnSchema,
            column5Label: z.string().nullable(),
            // companyName: z.string(),
            // companyStreet: z.string(),
            // companyCity: z.string(),
            // nip: z.string(),
            // krs: z.string(),
            // regon: z.string(),
            // additionalInfo: z.string().nullable(),
          }),
        })
        .transform((data) => {
          const {
            column1,
            column2,
            column3,
            column4,
            column1Label,
            column2Label,
            column3Label,
            column4Label,
            column5,
            column5Label,
            ...rest
          } = data.translations;

          return {
            translations: {
              ...rest,
              columns: [
                { items: column1, label: column1Label },
                { items: column2, label: column2Label },
                { items: column3, label: column3Label },
                { items: column4, label: column4Label },
                { items: column5, label: column5Label },
              ],
              cities: [{ items: column4, label: column4Label }],
              // companyInfo: {
              //   companyName: rest.companyName,
              //   companyStreet: rest.companyStreet,
              //   companyCity: rest.companyCity,
              //   nip: rest.nip,
              //   krs: rest.krs,
              //   regon: rest.regon,
              //   additionalInfo: rest.additionalInfo,
              // },
            },
          };
        }),
    ),
  })
  .transform(({ data }) => ({ ...data }));
